// Handle "View All Ingredients" button click
(function() {
  function initIngredientsButton() {
    // Find button with "ingredients" text in the set-info section
    const setInfoSection = document.querySelector('.ia-set-info-section');
    if (!setInfoSection) return;
    
    const buttons = setInfoSection.querySelectorAll('a, button');
    const ingredientsButton = Array.from(buttons).find(btn => {
      const text = btn.textContent.trim().toLowerCase();
      return text.includes('ingredients') || text.includes('view all ingredients');
    });
    
    if (!ingredientsButton) return;
    
    ingredientsButton.addEventListener('click', function(e) {
      e.preventDefault();
      let opened = false;
      
      // Find main product section
      const mainProductSection = document.querySelector('.section-main-product');
      if (!mainProductSection) return;
      
      // Find all accordions in main product section
      const accordions = mainProductSection.querySelectorAll('ia-accordion-component');
      
      // Find and open Ingredients accordion
      accordions.forEach(function(accordion) {
        const titleEl = accordion.querySelector('.ia-accordion-title');
        
        if (titleEl && titleEl.textContent.trim().toLowerCase().includes('ingredients')) {
          // Open the accordion
          accordion.open();
          opened = accordion;
          // Scroll to accordion
          setTimeout(function() {
            accordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 100);
        }
      });
      // Close all other accordions
      accordions.forEach(function(accordion) {
        if (opened && accordion !== opened) {
          accordion.close();
        }
      });
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIngredientsButton);
  } else {
    initIngredientsButton();
  }
})();
